import React from 'react';
import { CircularProgress, styled } from '@mui/material';

const PREFIX = 'PageLoader';

const classes = {
    statusMessage: `${PREFIX}-statusMessage`
};

const Root = styled('span')((
    {
        theme
    }
) => ({
    [`& .${classes.statusMessage}`]: {
        width: "100%",
        textAlign: "center",
        color: theme.palette.primary.main,
        fontSize: theme.typography.body1.fontSize,
        paddingTop: 100
    }
}));

const PageLoader = (props) => {


    const getStatusMessage = () => {
        return (
            <React.Fragment>
                <CircularProgress color="primary" variant="indeterminate" />
                <br />
                {props.message ?? "Please wait..."}
            </React.Fragment>
        );
    }

    return (
        <Root>
            <div className={classes.statusMessage}>
                {getStatusMessage()}
            </div>
        </Root>
    );
}

export default PageLoader;